module.exports = __webpack_public_path__ + "img/Art10-20180556-001.460cb2ce.jpg";